// App.js
import React, { useState, useContext, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ModalProvider, ModalContext } from './context/ModalContext.js';
import Navbar from './components/Navbar/Navbar.js';
import AboutModal from './components/AboutModal/AboutModal.js';
import TableView from './components/TableView/TableView.js';
import PopupModal from './components/PopupModal/PopupModal.js';
import Map from './components/map.js';
import Legend from './components/Legend/Legend.js';

const AppContent = () => {
  const [filters, setFilters] = useState({
    policyTypes: [],
    policySubtypes: [],
    communitySize: [],
    geographyType: [],
    populationRange: null
  });
  const [hasShownPopup, setHasShownPopup] = useState(false);
  const { openModal } = useContext(ModalContext);
  const [isFilterMenuVisible, setIsFilterMenuVisible] = useState(false);
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(0);

  useEffect(() => {
    // Only show popup on first load
    if (!hasShownPopup) {
      openModal('popup');
      setHasShownPopup(true);
    }
  }, [openModal, hasShownPopup]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleFilterMenuOpen = () => {
    setIsFilterMenuVisible(true);
  };

  const handleClearFilters = () => {
    const emptyFilters = {
      policyTypes: [],
      policySubtypes: [],
      communitySize: [],
      geographyType: [],
      populationRange: null,
      cityPopulation: null,
      countyPopulation: null
    };
    setFilters(emptyFilters);
    setClearFiltersTrigger(prev => prev + 1); // Increment to trigger clear in FilterMenu
  };

  return (
    <div className="App">
      <Navbar />
      <Map 
        onFilterChange={handleFilterChange} 
        isFilterMenuVisible={isFilterMenuVisible}
        setIsFilterMenuVisible={setIsFilterMenuVisible}
        clearFiltersTrigger={clearFiltersTrigger}
      />
      <AboutModal />
      <TableView 
        filters={filters} 
        onFilterMenuOpen={() => setIsFilterMenuVisible(true)}
        onFilterChange={handleFilterChange}
        onClearFilters={handleClearFilters}
      />
      <PopupModal />
      <Legend /> 
    </div>
  );
};

const App = () => {
  return (
    <ModalProvider>
      <AppContent />
    </ModalProvider>
  );
};

export default App;